export enum FireOutbreakOccurrenceEnum {
	FARM = 'farm',
	BUFFER = 'buffer',
}
